
export default {
  name: 'SectionTabs',
  components: {},
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    tab_model: 0,
    isMobile: false
  }),
  computed: {},
  created() {},
  beforeDestroy() {
    window.removeEventListener('resize', this.setViewport)
  },
  mounted() {
    window.addEventListener('resize', this.setViewport)
    this.setViewport()
  },
  methods: {
    setViewport() {
      this.isMobile = window.innerWidth < 1025
    }
  }
}
